const ROWS = [
  { name: 'intake.agent',   dot: 'n', bar: false, st: 'done',   label: 'Complete' },
  { name: 'research.agent', dot: 'g', bar: true,  st: 'run',    label: 'Running'  },
  { name: 'draft.agent',    dot: 'n', bar: false, st: 'queued', label: 'Queued'   },
  { name: 'review.agent',   dot: 'n', bar: false, st: 'wait',   label: 'Waiting'  },
];

export function MkQueue() {
  return (
    <div className="csmk csmk-queue">
      <div className="qhd">
        <span className="ttl">Agent pipeline</span>
        <span className="badge">AIR-GAPPED · GPU ON-PREM</span>
      </div>
      {ROWS.map((r, i) => (
        <div className="arow" key={i}>
          <span className="name">
            <span className={`dot ${r.dot}`} />{r.name}
          </span>
          {r.bar && <span className="pbar"><b /></span>}
          <span className={`stat ${r.st}`}>{r.label}</span>
        </div>
      ))}
      <div className="qfoot">
        <span>jobs: <b>4/06</b></span>
        <span>queue: <b>3</b></span>
        <span>uptime: <b>99.8%</b></span>
      </div>
    </div>
  );
}
